import React from "react";
import {
  Navbar as MaterialNavbar,
  MobileNav,
  Typography,
  Button,
  IconButton,
  Card,
  Collapse,
} from "@material-tailwind/react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/final_logo_transparent.png"
import logoWhite from "../assets/final_logo_white.png"

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

export function Navbar({ transparent = true }) {
  const [openNav, setOpenNav] = React.useState(false);
  const navigate = useNavigate()

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false),
    );
  }, []);


  const navList = (
    <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 ">
      <Typography
        as="li"
        className="font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
        onClick={() => navigate("/")}
      >
        <a  className="flex items-center h-full">
          GENERAL INFORMATION
        </a>
      </Typography>
      <Typography
        as="li"
        className="p-1 font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
        onClick={() => navigate("/callforpapers")}
      >
        <a  className="flex items-center">
          CALL FOR PAPERS
        </a>
      </Typography>
      <Typography
        as="li"
        className="p-1 font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
        onClick={() => navigate("/program")}
      >
        <a  className="flex items-center ">
          PROGRAM
        </a>
      </Typography>
      {/* <Typography
        as="li"
        className="p-1 font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
      >
        <a to="/submission" className="flex items-center ">
          SUBMISSION
        </a>
      </Typography> */}
      <Typography
        as="li"
        className="p-1 font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
        onClick={() => navigate("/registration")}
      >
        <a  className="flex items-center">
          REGISTRATION
        </a>
      </Typography>

      <Typography
        as="li"
        className="p-1 font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
        onClick={() => navigate("/committees")}
      >
        <a  className="flex items-center">
          COMMITTEES
        </a>
      </Typography>

      <Typography
        as="li"
        className="p-1 font-semibold hover:text-ubi-500 duration-200 text-sm cursor-pointer"
        onClick={() => navigate("/sponsorship-packages")}
      >
        <a className="flex items-center">
          SPONSORSHIP
        </a>
      </Typography>
    </ul>
  );

  return (


    <div className="fixed top-0 z-50 w-full h-max max-w-full rounded-none bg-transparent" >

      <header
        className={classNames(
          "duration-300 px-4 py-2  ",
          transparent ? "lg:bg-transparent lg:text-gray-200 " : 'bg-white  text-gray-500 shadow-xl shadow-primary-600/20',
          openNav ? "bg-white text-gray-500" : ""
        )}
      >

        <div className={classNames(
          "flex items-center justify-between ",
          openNav ? "text-gray-500" : "",
          transparent && !openNav ? "text-white" : "text-blue-gray-900",
        )}>
          <Typography
            className="mr-4 cursor-pointer py-1.5 font-bold text-xl"
          >
            <img className={
              classNames(
                "w-24",
                // "invert grayscale"
              )}
              src={transparent ? logoWhite : logo}
              alt="logo" 
              onClick={() => navigate("/")}
              />
            {/* <Link to="/" >
              RECPAD 2024

            </Link> */}
          </Typography>
          <div className="flex items-center gap-4">
            <div className="mr-4 hidden lg:block">{navList}</div>
            <div className="flex items-center gap-x-1">

            </div>
            <IconButton
              variant="text"
              className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
              ripple={false}
              onClick={() => setOpenNav(!openNav)}
            >
              {openNav ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </IconButton>
          </div>
        </div>
        <Collapse open={openNav} className="text-gray-500" >
          {navList}
          <div className="flex items-center gap-x-1">

          </div>
        </Collapse>
      </header>
    </div>
  );
}